module.exports = __webpack_public_path__ + "img/delete_row.fe3045db.svg";